import { createUseStyles } from 'react-jss';

export const useAmbassadorThird = createUseStyles({
  bgLensHand: {
    backgroundImage: 'url("/images/ambassadors/hand_holding_lenses.png")',
    backgroundPosition: '0 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '225px auto',
  },
});
